// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronUpIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChevronUpIcon" ref={forwardedRef} {...props}>
      <path d="M16.364 12.364 10 6l-6.364 6.364 1.057 1.057L10 8.121l5.303 5.304z" />
    </SvgIcon>
  );
});

/**
 * Indicates the ability to collapse a dropdown
 * @public
 */
export const ChevronUpIcon = /* @__PURE__ */ Object.assign(
  ChevronUpIconComponent,
  { displayName: 'ChevronUpIcon' },
);
